import React from 'react';
import PropTypes from 'prop-types';
import store from '../../store';
import Button from '../Button';
import ContentContainer from '../ContentContainer';
import LocaleText from '../LocaleText';

class CheckoutFooter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            steps: props.steps,
            current: props.current,
            show: typeof props.show === 'boolean' ? props.show : true,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({
                current: nextProps.current,
                show: typeof nextProps.show === 'boolean' ? nextProps.show : true,
            });
        }
    }

    render() {
        const btnText =
            this.state.current === this.state.steps.length - 1 ? (
                <LocaleText textKey="checkout.send.button.label" />
            ) : (
                <LocaleText textKey="checkout.cta.primary" />
            );
        return (
            <div className={`checkout-footer ${this.state.show ? 'is-on' : 'is-off'}`}>
                <ContentContainer>
                    <div className="checkout-footer__inner">
                        {this.props.children}
                        <p>
                            <LocaleText textKey="checkout.required.fields.notice" />
                        </p>
                        <p>
                            <LocaleText textKey="checkout.pdf.notice" />
                        </p>
                        <div className="checkout-footer__nav">
                            <span className="prev">
                                <Button onClick={this.props.onPrev} className="is-bigger">
                                    <LocaleText textKey="checkout.cta.secondary" />
                                </Button>
                            </span>
                            {this.props.showGeneratePdf ? (
                                <span className="pdf-download">
                                    <Button
                                        onClick={
                                            this.props.isPdfGenerating
                                                ? () => {}
                                                : this.props.onGeneratePdf
                                        }
                                        className="is-bigger"
                                    >
                                        {this.props.isPdfGenerating ? (
                                            <LocaleText textKey="checkout.cta.pdf.loading" />
                                        ) : (
                                            <LocaleText textKey="checkout.cta.pdf.generate" />
                                        )}
                                    </Button>
                                </span>
                            ) : null}
                            {this.props.showPdfDownload && (
                                <span className="pdf-download">
                                    <a href={this.props.pdfUrl} target="_blank" download>
                                        <Button className="is-bigger">
                                            <LocaleText textKey="checkout.cta.pdf.download" />
                                        </Button>
                                    </a>
                                </span>
                            )}
                            <span className="next">
                                <Button
                                    onClick={this.props.onNext}
                                    className="is-primary is-bigger"
                                >
                                    {btnText}
                                </Button>
                            </span>
                        </div>
                    </div>
                </ContentContainer>
            </div>
        );
    }
}

CheckoutFooter.propTypes = {
    children: PropTypes.node,
    steps: PropTypes.array.isRequired,
    current: PropTypes.number.isRequired,
    show: PropTypes.bool,
    onPrev: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onGeneratePdf: PropTypes.func,
    showPdfDownload: PropTypes.bool,
    showGeneratePdf: PropTypes.bool,
    pdfUrl: PropTypes.string,
};

CheckoutFooter.defaultProps = {
    onPdfDownload: () => {},
    showPdfDownload: false,
    showGeneratePdf: false,
    pdfUrl: undefined,
};

export default CheckoutFooter;
